import { AuditStatusPill } from "../../AuditMaster/components/AuditMasterDataTable.config";
import { RemarkText, ThirdPartyAuditStatusPill } from "../../ThirdPartyAuditMaster/components/ThirdPartyAuditMaster.config";

// Column config for audit report data table
export const auditReportDataTableColumns = [
  {
    label: "Audit Id",
    excelName: "Audit Id",
    isSort: false,
    id: "auditId",
    excelDataField: "auditId",
    isIcon: false,
  },
  {
    label: "Audit Type",
    excelName: "Audit Type",
    isSort: false,
    id: "auditTypeName",
    excelDataField: "auditTypeName",
    isIcon: false,
  },
  {
    label: "Status",
    excelName: "Status",
    isSort: false,
    id: "status",
    excelDataField: "status",
    isIcon: false,
  },
  {
    label: "Branch",
    excelName: "Branch",
    isSort: false,
    id: "branchName",
    excelDataField: "branchName",
    isIcon: false,
  },
  {
    label: "Department",
    excelName: "Department",
    isSort: false,
    id: "departmentName",
    excelDataField: "departmentName",
    isIcon: false,
  },
  {
    label: "Area",
    excelName: "Area",
    isSort: false,
    id: "areaName",
    excelDataField: "areaName",
    isIcon: false,
  },
  {
    label: "Created By",
    excelName: "Created By",
    isSort: false,
    id: "createdByName",
    excelDataField: "createdByName",
    isIcon: false,
  },
  {
    label: "Auditor Name",
    excelName: "Auditor Name",
    isSort: false,
    id: "auditorName",
    excelDataField: "auditorName",
    isIcon: false,
  },
  {
    label: "Auditee Name",
    excelName: "Auditee Name",
    isSort: false,
    id: "auditeeName",
    excelDataField: "auditeeName",
    isIcon: false,
  },
  {
    label: "Start Date",
    excelName: "Start Date",
    isSort: true,
    id: "readableStartDate",
    excelDataField: "readableStartDate",
    // isDate: true,
    isIcon: false,
  },
  {
    label: "End Date",
    excelName: "End Date",
    isSort: true,
    id: "readableEndDate",
    excelDataField: "readableEndDate",
    // isDate: true,
    isIcon: false,
  },
  {
    label: "Created On",
    excelName: "Created On",
    isSort: true,
    id: "createdAt",
    excelDataField: "createdAtForExcel",
    // isDate: true,
    isIcon: false,
  },
  {
    label: "Updated On",
    excelName: "Updated On",
    isSort: true,
    id: "updatedAt",
    excelDataField: "updatedAtForExcel",
    // isDate: true,
    isIcon: false,
  },
];

// Select "All" option
export const select_all_obj = [
  {
    label: "All",
    value: "All",
  },
];



// Tabs to switch between different types of report
export const TabListConfigForReport = [
  {
    label: "Internal Audit Report",
    value: "1",
  },
  {
    label: "NC Report Of Internal Audits",
    value: "2",
  },
  {
    label: "Third Party Audit Report",
    value: "3",
  },
]

export const NCReportParentDataTableColumns = [
  {
    name: "Audit Id",
    excelName: "Audit Id",
    excelDataField: "auditId",
    selector: row => row.auditId,
    width: '150px',
    cell: row => (
      <div title={row.auditId}>
        {row.auditId}
      </div>
    )
  },
  {
    name: "Audit Type Category",
    excelName: "Audit Type Category",
    excelDataField: "auditTypeCategoryName",
    selector: row => row.auditTypeCategoryName,
    width: '170px',
    cell: row => row.auditTypeCategoryName
  },
  {
    name: "Audit Type",
    excelName: "Audit Type",
    excelDataField: "auditTypeName",
    selector: row => row.auditTypeName,
    cell: row => row.auditTypeName
  },
  {
    name: "Status",
    excelName: "Status",
    excelDataField: "status",
    selector: row => row.status,
    // width: "5.5rem",
    cell: row => <AuditStatusPill data={row.status} />
  },
  {
    name: "Total Activities",
    excelName: "Total Activities",
    excelDataField: "totalActivities",
    selector: row => row.totalActivities,
    // width: "5.5rem",
    cell: row => row.totalActivities
  },
  {
    name: "Confirmed Activities",
    excelName: "Confirmed Activities",
    excelDataField: "confirmedActivities",
    selector: row => row.confirmedActivities,
    // width: "5.5rem",
    cell: row => row.confirmedActivities
  },
  {
    name: "Total NC's",
    excelName: "Total NC's",
    excelDataField: "ncOrAOIActivities",
    selector: row => row.ncOrAOIActivities,
    // width: "5.5rem",
    cell: row => row.ncOrAOIActivities
  },
  {
    name: "Open NC's",
    excelName: "Open NC's",
    excelDataField: "openActivities",
    selector: row => row.openActivities,
    // width: "5.5rem",
    cell: row => row.openActivities
  },
  {
    name: "Closed NC's",
    excelName: "Closed NC's",
    excelDataField: "closedActivities",
    selector: row => row.closedActivities,
    // width: "5.5rem",
    cell: row => row.closedActivities
  },
  {
    name: "Branch",
    excelName: "Branch",
    excelDataField: "branchName",
    selector: row => row.branchName,
    cell: row => row.branchName
  },
  {
    name: "Department",
    excelName: "Department",
    excelDataField: "departmentName",
    selector: row => row.departmentName,
    width: "200px",
    cell: row => row.departmentName
  },
  {
    name: "Area",
    excelName: "Area",
    excelDataField: "areaName",
    selector: row => row.areaName,
    width: "200px",
    cell: row => row.areaName
  },
  {
    name: "Created By",
    excelName: "Created By",
    excelDataField: "createdByName",
    selector: row => row.createdByName,
    // width: "5.5rem",
    cell: row => row.createdByName
  },
  {
    name: "Auditor Name",
    excelName: "Auditor Name",
    excelDataField: "auditorName",
    selector: row => row.auditorName,
    // width: "5.5rem",
    cell: row => row.auditorName
  },
  {
    name: "Auditee Name",
    excelName: "Auditee Name",
    excelDataField: "auditeeName",
    selector: row => row.auditeeName,
    // width: "5.5rem",
    cell: row => row.auditeeName
  },
  {
    name: "Start Date",
    excelName: "Start Date",
    excelDataField: "startDate",
    isDate: true,
    selector: row => row.readableStartDate,
    // width: "5.5rem",
    cell: row => row.readableStartDate
  },
  {
    name: "End Date",
    excelName: "End Date",
    excelDataField: "endDate",
    isDate: true,
    selector: row => row.readableEndDate,
    // width: "5.5rem",
    cell: row => row.readableEndDate
  },
  {
    name: "Created On",
    excelName: "Created On",
    excelDataField: "createdAtForExcel",
    isDate: true,
    selector: row => row.createdAt,
    // width: "5.5rem",
    cell: row => row.createdAt
  },
  {
    name: "Updated On",
    excelName: "Updated On",
    excelDataField: "updatedAtForExcel",
    isDate: true,
    selector: row => row.updatedAt,
    // width: "5.5rem",
    cell: row => row.updatedAt
  },

]

export const NCReportChildDataTableColumns = [
  {
    name: <div>Activity Name</div>,
    excelName: "Activity Name",
    selector: row => row.name,
    cell: row => row.name
  },
  {
    name: <div>Progress Status</div>,
    excelName: "Progress Status",
    selector: row => row.complianceStatus,
    cell: row => row.complianceStatus
  },
  {
    name: <div>Observation By Auditor</div>,
    excelName: "Observation By Auditor",
    selector: row => row.auditorObservation,
    cell: row => row.auditorObservation
  },
  {
    name: <div>CAPA</div>,
    excelName: "CAPA",
    selector: row => row.capa,
    cell: row => row.capa
  },
  {
    name: <div>Audit Point Status</div>,
    excelName: "Audit Point Status",
    selector: row => row.verificationStatus,
    cell: row => row.verificationStatus
  },
  {
    name: <div>Remarks By Auditee</div>,
    excelName: "Remarks By Auditee",
    selector: row => row.remark,
    cell: row => row.remark
  },
  {
    name: <div>Target Date</div>,
    excelName: "Target Date",
    selector: row => row.targetDate,
    cell: row => row.targetDate
  },
]




//  --------------------- ONLY FOR THIRD PARTY AUDITS ----------------------
export const NCReportParentDataTableColumnsForThirdPartyAudits = [
  {
    name: "Audit Id",
    excelName: "Audit Id",
    excelDataField: "auditId",
    selector: row => row.auditId,
    width: '150px',
    cell: row => (
      <div title={row.auditId}>
        {row.auditId}
      </div>
    )
  },
  {
    name: "Audit Type Category",
    excelName: "Audit Type Category",
    excelDataField: "auditTypeCategoryName",
    selector: row => row.auditTypeCategoryName,
    width: '170px',
    cell: row => row.auditTypeCategoryName
  },
  {
    name: "Audit Type",
    excelName: "Audit Type",
    excelDataField: "auditTypeName",
    selector: row => row.auditTypeName,
    cell: row => row.auditTypeName
  },
  {
    name: "Status",
    excelName: "Status",
    excelDataField: "status",
    selector: row => row.status,
    width: "7rem",
    cell: row => <ThirdPartyAuditStatusPill data={row.status} />
  },
  {
    name: "Remark",
    excelName: "Remark",
    excelDataField: "remark",
    selector: row => row.remark,
    // width: "5.5rem",
    cell: row => <RemarkText data={row.remark}/>
  },
  {
    name: "Total Activities",
    excelName: "Total Activities",
    excelDataField: "totalActivitiesCount",
    selector: row => row.totalActivitiesCount,
    // width: "5.5rem",
    cell: row => row.totalActivitiesCount
  },
  {
    name: "Total NC's",
    excelName: "Total NC's",
    excelDataField: "totalNCActivitiesCount",
    selector: row => row.totalNCActivitiesCount,
    // width: "5.5rem",
    cell: row => row.totalNCActivitiesCount
  },
  {
    name: "Closed NC's",
    excelName: "Closed NC's",
    excelDataField: "closedActivitiesCount",
    selector: row => row.closedActivitiesCount,
    // width: "5.5rem",
    cell: row => row.closedActivitiesCount
  },
  {
    name: "Branch",
    excelName: "Branch",
    excelDataField: "branchName",
    selector: row => row.branchName,
    cell: row => row.branchName
  },
  {
    name: "Department",
    excelName: "Department",
    excelDataField: "departmentName",
    selector: row => row.departmentName,
    width: "200px",
    cell: row => row.departmentName
  },
  {
    name: "Area",
    excelName: "Area",
    excelDataField: "areaName",
    selector: row => row.areaName,
    width: "200px",
    cell: row => row.areaName
  },
  {
    name: "Created By",
    excelName: "Created By",
    excelDataField: "createdByName",
    selector: row => row.createdByName,
    // width: "5.5rem",
    cell: row => row.createdByName
  },
  {
    name: "Auditor Name",
    excelName: "Auditor Name",
    excelDataField: "auditorName",
    selector: row => row.auditorName,
    // width: "5.5rem",
    cell: row => row.auditorName
  },
  {
    name: "Start Date",
    excelName: "Start Date",
    excelDataField: "startDate",
    isDate: true,
    selector: row => row.readableStartDate,
    // width: "5.5rem",
    cell: row => row.readableStartDate
  },
  {
    name: "End Date",
    excelName: "End Date",
    excelDataField: "endDate",
    isDate: true,
    selector: row => row.readableEndDate,
    // width: "5.5rem",
    cell: row => row.readableEndDate
  },
  {
    name: "Created On",
    excelName: "Created On",
    excelDataField: "createdAtForExcel",
    isDate: true,
    selector: row => row.createdAt,
    // width: "5.5rem",
    cell: row => row.createdAt
  },
  {
    name: "Updated On",
    excelName: "Updated On",
    excelDataField: "updatedAtForExcel",
    isDate: true,
    selector: row => row.updatedAt,
    // width: "5.5rem",
    cell: row => row.updatedAt
  },
]


export const NCReportChildDataTableColumnsForThirdParty = [
  {
    name: <div>Activity Name</div>,
    excelName: "Activity Name",
    selector: (row) => row.activityName,
    cell: (row) => row.activityName,
  },
  {
    name: <div>Observation By Auditor</div>,
    excelName: "Observation By Auditor",
    selector: (row) => row.auditorObservation,
    cell: (row) => row.auditorObservation,
  },
  {
    name: <div>CAPA</div>,
    excelName: "CAPA",
    selector: (row) => row.capa,
    cell: (row) => row.capa,
  },
  {
    name: <div>Attachments</div>,
    excelName: "CAPA",
    selector: (row) => row?.attachments,
    cell: (row) => (
      <div>
        {row.attachments?.length > 0
          ? `${row.attachments.length} file${
              row.attachments.length > 1 ? "s" : ""
            } uploaded`
          : "Not uploaded"}
      </div>
    ),
  },
];